import script from "./ReorderPagesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReorderPagesModal.vue?vue&type=script&setup=true&lang=js"

import "./ReorderPagesModal.vue?vue&type=style&index=0&id=15f9d95d&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f9d95d"]])

export default __exports__